<div id="vtz-main-wrapper" class="vtz-main-wrapper">
    <div id="vtz-main-container" class="vtz-main-container vtz-main-container--ballot">
      <div id="vtz-title-section" class="vtz-title-section vtz-title-section--blue">
        <app-header></app-header>
      </div>
      <main>
      <h1 id="vtz-title-section-text" class="vtz-h1" i18n>
          Your decision to decline to vote has been successfully submitted.
      </h1>
      <div id="vtz-success-code-wrapper" class="vtz-success-code__wrapper">
        @if (confirmationType?.includes('ONSCREEN') && ballotType !== 'PETITION') {
          @if (emailUsed()) {
            <p id="vtz-success-code-text" class="vtz-text vtz-text--wide vtz-text--center" i18n>
              The following is your Confirmation ID, which verifies this submission. It has also been sent to the email you provided upon signup.
            </p>
          } @else {
            <p id="vtz-success-code-text" class="vtz-text vtz-text--wide vtz-text--center" i18n>
              The following is your Confirmation ID, which verifies this submission.
            </p>
          }
          <div id="vtz-success-code-container" class="vtz-success-code__container">
            <span id="vtz-success-code-code" class="vtz-success-code__text" 
            [attr.aria-label]="spaceOut(confirmationId)">
              {{confirmationId}}
            </span>
          </div>
        }
        <p id="vtz-success-code-subtext3" class="vtz-text vtz-text--wide vtz-text--center vtz-text--extra-space" i18n>
          Thank you for using the Voatz Web App! Please be sure to end your session to close the app.
        </p>
      </div>
      <div id="vtz-actions" class="vtz-actions">
        <div id="vtz-button-group" class="button-group button-group--sucess">
          <button id="cancel-button" class="button-secondary vtz--hide-mobile" (click)="print()" i18n="Button label">PRINT PAGE</button>
          <button id="submit-button" class="button-primary"  i18n="Button label" (click)="exit()">END SESSION</button>
        </div>
      </div>
    </main>
    </div>
  </div>
  <app-back-button-confirmation-modal>
  </app-back-button-confirmation-modal>
  